import React from 'react'
import PropTypes from 'prop-types'
import {TopAppBarFixedAdjust as RmwcTopAppBarFixedAdjust} from '@rmwc/top-app-bar'
import '@rmwc/top-app-bar/styles'

const TopAppBarFixedAdjust = ({children, ...otherProps}) => <RmwcTopAppBarFixedAdjust {...otherProps}>{children}</RmwcTopAppBarFixedAdjust>

TopAppBarFixedAdjust.propTypes = {
  children: PropTypes.any
}

export {TopAppBarFixedAdjust}
